import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { AuditsActionTypes, AuditsState } from './types'

export const FILTER_PERSISTOR = createFilter(
  'audits',
  null,
  ['filterStatus'],
  'whitelist'
)

const INITIAL_STATE: AuditsState = {
  error: '',
  filterRequestNumber: '',
  filterRequestTravelerName: '',
  filterStatus: [],
  list: [],
  loading: false,
  total_results: 0
}

const reducer: Reducer<AuditsState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    /**
     * GET_AUDITOR
     */
    case AuditsActionTypes.GET_AUDITS:
      const filterRequestNumber: string =
        typeof payload.options.request_numbers !== 'undefined'
          ? payload.options.request_numbers
          : state.filterRequestNumber
      const filterRequestTravelerName: string =
          typeof payload.options.traveler_name !== 'undefined'
            ? payload.options.traveler_name
            : state.filterRequestTravelerName
      const filterStatus: string[] =
        typeof payload.options.filterStatus !== 'undefined'
          ? payload.options.filterStatus
          : state.filterStatus

      return {
        ...state,
        error: '',
        filterRequestNumber,
        filterRequestTravelerName,
        filterStatus,
        loading: true
      }
    case AuditsActionTypes.GET_AUDITS_SUCCESS:
      return {
        ...state,
        list: payload.requests,
        loading: false,
        total_results: payload.totalResults
      }
    case AuditsActionTypes.GET_AUDITS_FAILURE:
      return {
        ...state,
        error: payload.message,
        loading: false
      }
    default:
      return state
  }
}

export default reducer
